module.exports = __webpack_public_path__ + "static/media/caseiq.abb0d3ce.jpg";